import React from "react";

const File = () => {
  return (
    <form>
      <div className="w-64 mt-10 ml-2">
        <select className="w-full border border-gray-300 rounded-lg p-2 text-gray-700">
          <option value="More Settings" className="py-2">
            More Settings
          </option>
          <option value="option1" className="py-2">
            Change Password
          </option>
          <option value="option2" className="py-2">
            Disable Account
          </option>
          <option value="option3" className="py-2">
            Logout
          </option>
        </select>
      </div>
    </form> 
  );
};

export default File;
